<template>
  <div class="accordion">
    <button
      type="button"
      :aria-expanded="isOpen"
      :aria-controls="`accordion-panel-${section.id}`"
      :id="`accordion-header-${section.id}`"
      class="accordion-trigger px-4 py-3 w-full transition-all duration-300 outline-0 focus:outline-none bg-light text-left"
      @click="$emit('toggle')"
    >
      <span class="accordion-title flex items-center justify-between">
        <h4 class="font-bold">{{ section.title }}</h4>
        <div
          class="flex h-6 w-6 flex-none items-center justify-center rounded-full bg-white text-primary tablet:h-8 tablet:w-8 transition-transform duration-300"
          :class="{ 'rotate-180': isOpen }"
        >
          <svg class="h-3 w-3 tablet:h-4 tablet:w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </span>
    </button>
    <div
      :id="`accordion-panel-${section.id}`"
      role="region"
      :aria-labelledby="`accordion-header-${section.id}`"
      class="accordion-panel bg-light overflow-hidden transition-all duration-300"
      :class="{ 'accordion-panel--open': isOpen }"
      :aria-hidden="!isOpen"
    >
      <div class="accordion-panel__content">
        <div class="space-y-4 px-4 py-6">
          <ContentBlockRenderer :blocks="section.content" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ContentBlockRenderer from './ContentBlockRenderer.vue'

defineProps({
  section: {
    type: Object,
    required: true
  },
  isOpen: {
    type: Boolean,
    default: false
  }
})

defineEmits(['toggle'])
</script>

<style scoped>
.accordion-panel__content {
  max-height: 0;
  transition: max-height 0.3s ease-out;
}

.accordion-panel--open .accordion-panel__content {
  max-height: 5000px;
  transition: max-height 0.4s ease-in;
}

.accordion-trigger {
  cursor: pointer;
}

.accordion-trigger:hover {
  background-color: rgb(0 0 0 / 0.03);
}

.accordion-trigger:focus-visible {
  outline: 2px solid var(--color-primary-500);
  outline-offset: 2px;
}
</style>
